var map = {
	"./$pac.svg": 536,
	"./0xbtc.svg": 537,
	"./2give.svg": 538,
	"./abt.svg": 539,
	"./act.svg": 540,
	"./actn.svg": 541,
	"./ada.svg": 542,
	"./add.svg": 543,
	"./adx.svg": 544,
	"./ae.svg": 545,
	"./aeon.svg": 546,
	"./aeur.svg": 547,
	"./agi.svg": 548,
	"./agrs.svg": 549,
	"./aion.svg": 550,
	"./amb.svg": 551,
	"./amp.svg": 552,
	"./ant.svg": 553,
	"./apex.svg": 554,
	"./appc.svg": 555,
	"./ardr.svg": 556,
	"./arg.svg": 557,
	"./ark.svg": 558,
	"./arn.svg": 559,
	"./ary.svg": 560,
	"./ast.svg": 561,
	"./atm.svg": 562,
	"./atom.svg": 563,
	"./audr.svg": 564,
	"./auto.svg": 565,
	"./aywa.svg": 566,
	"./bab.svg": 567,
	"./bat.svg": 568,
	"./bay.svg": 569,
	"./bcbc.svg": 570,
	"./bcc.svg": 571,
	"./bcd.svg": 572,
	"./bch.svg": 573,
	"./bcio.svg": 574,
	"./bcn.svg": 575,
	"./bco.svg": 576,
	"./bcpt.svg": 577,
	"./bdl.svg": 578,
	"./beam.svg": 579,
	"./bela.svg": 580,
	"./bix.svg": 581,
	"./blcn.svg": 582,
	"./blk.svg": 583,
	"./block.svg": 584,
	"./blz.svg": 585,
	"./bnb.svg": 586,
	"./bnt.svg": 587,
	"./bnty.svg": 588,
	"./booty.svg": 589,
	"./bos.svg": 590,
	"./bpt.svg": 591,
	"./bq.svg": 592,
	"./brd.svg": 593,
	"./bsd.svg": 594,
	"./bsv.svg": 595,
	"./btc.svg": 596,
	"./btcd.svg": 597,
	"./btch.svg": 598,
	"./btcp.svg": 599,
	"./btcz.svg": 600,
	"./btdx.svg": 601,
	"./btg.svg": 602,
	"./btm.svg": 603,
	"./bts.svg": 604,
	"./btt.svg": 605,
	"./btx.svg": 606,
	"./burst.svg": 607,
	"./call.svg": 608,
	"./cc.svg": 609,
	"./cdn.svg": 610,
	"./cdt.svg": 611,
	"./cenz.svg": 612,
	"./chain.svg": 613,
	"./chat.svg": 614,
	"./chips.svg": 615,
	"./cix.svg": 616,
	"./clam.svg": 617,
	"./cloak.svg": 618,
	"./cmm.svg": 619,
	"./cmt.svg": 620,
	"./cnd.svg": 621,
	"./cnx.svg": 622,
	"./cny.svg": 623,
	"./cob.svg": 624,
	"./colx.svg": 625,
	"./coqui.svg": 626,
	"./cred.svg": 627,
	"./crpt.svg": 628,
	"./crw.svg": 629,
	"./cs.svg": 630,
	"./ctr.svg": 631,
	"./ctxc.svg": 632,
	"./cvc.svg": 633,
	"./d.svg": 634,
	"./dai.svg": 635,
	"./dash.svg": 636,
	"./dat.svg": 637,
	"./data.svg": 638,
	"./dbc.svg": 639,
	"./dcn.svg": 640,
	"./dcr.svg": 641,
	"./deez.svg": 642,
	"./default.svg": 643,
	"./dent.svg": 644,
	"./dew.svg": 645,
	"./dgb.svg": 646,
	"./dgd.svg": 647,
	"./dlt.svg": 648,
	"./dnt.svg": 649,
	"./dock.svg": 650,
	"./doge.svg": 651,
	"./drgn.svg": 652,
	"./drop.svg": 653,
	"./dta.svg": 654,
	"./dth.svg": 655,
	"./dtr.svg": 656,
	"./ebst.svg": 657,
	"./eca.svg": 658,
	"./edg.svg": 659,
	"./edo.svg": 660,
	"./edoge.svg": 661,
	"./ela.svg": 662,
	"./elec.svg": 663,
	"./elf.svg": 664,
	"./elix.svg": 665,
	"./ella.svg": 666,
	"./emc.svg": 667,
	"./emc2.svg": 668,
	"./eng.svg": 669,
	"./enj.svg": 670,
	"./entrp.svg": 671,
	"./eon.svg": 672,
	"./eop.svg": 673,
	"./eos.svg": 674,
	"./eqli.svg": 675,
	"./equa.svg": 676,
	"./etc.svg": 677,
	"./eth.svg": 678,
	"./ethos.svg": 679,
	"./etn.svg": 680,
	"./etp.svg": 681,
	"./eur.svg": 682,
	"./evx.svg": 683,
	"./exmo.svg": 684,
	"./exp.svg": 685,
	"./fair.svg": 686,
	"./fct.svg": 687,
	"./fil.svg": 688,
	"./fjc.svg": 689,
	"./fldc.svg": 690,
	"./flo.svg": 691,
	"./fsn.svg": 692,
	"./ftc.svg": 693,
	"./fuel.svg": 694,
	"./fun.svg": 695,
	"./game.svg": 696,
	"./gas.svg": 697,
	"./gbp.svg": 698,
	"./gbx.svg": 699,
	"./gbyte.svg": 700,
	"./generic.svg": 701,
	"./gin.svg": 702,
	"./glxt.svg": 703,
	"./gmr.svg": 704,
	"./gno.svg": 705,
	"./gnt.svg": 706,
	"./gold.svg": 707,
	"./grc.svg": 708,
	"./grin.svg": 709,
	"./grs.svg": 710,
	"./gsc.svg": 711,
	"./gto.svg": 712,
	"./gup.svg": 713,
	"./gusd.svg": 714,
	"./gvt.svg": 715,
	"./gxs.svg": 716,
	"./gzr.svg": 717,
	"./hight.svg": 718,
	"./hodl.svg": 719,
	"./hot.svg": 720,
	"./hpb.svg": 721,
	"./hsr.svg": 722,
	"./ht.svg": 723,
	"./html.svg": 724,
	"./huc.svg": 725,
	"./hush.svg": 726,
	"./icn.svg": 727,
	"./icx.svg": 728,
	"./ignis.svg": 729,
	"./ilk.svg": 730,
	"./imbtc.svg": 731,
	"./ink.svg": 732,
	"./ins.svg": 733,
	"./ion.svg": 734,
	"./iop.svg": 735,
	"./iost.svg": 736,
	"./iotx.svg": 737,
	"./iq.svg": 738,
	"./itc.svg": 739,
	"./jnt.svg": 740,
	"./jpy.svg": 741,
	"./kcs.svg": 742,
	"./kin.svg": 743,
	"./kmd.svg": 744,
	"./knc.svg": 745,
	"./krb.svg": 746,
	"./lbc.svg": 747,
	"./lend.svg": 748,
	"./link.svg": 749,
	"./lkk.svg": 750,
	"./loom.svg": 751,
	"./lpt.svg": 752,
	"./lrc.svg": 753,
	"./lsk.svg": 754,
	"./ltc.svg": 755,
	"./lun.svg": 756,
	"./maid.svg": 757,
	"./mana.svg": 758,
	"./matic.svg": 759,
	"./mcap.svg": 760,
	"./mco.svg": 761,
	"./mda.svg": 762,
	"./mds.svg": 763,
	"./med.svg": 764,
	"./meetone.svg": 765,
	"./mft.svg": 766,
	"./miota.svg": 767,
	"./mith.svg": 768,
	"./mkr.svg": 769,
	"./mln.svg": 770,
	"./mnx.svg": 771,
	"./mnz.svg": 772,
	"./moac.svg": 773,
	"./mod.svg": 774,
	"./mona.svg": 775,
	"./msr.svg": 776,
	"./mth.svg": 777,
	"./mtl.svg": 778,
	"./music.svg": 779,
	"./mzc.svg": 780,
	"./nano.svg": 781,
	"./nas.svg": 782,
	"./nav.svg": 783,
	"./ncash.svg": 784,
	"./ndz.svg": 785,
	"./nebl.svg": 786,
	"./neo.svg": 787,
	"./neos.svg": 788,
	"./neu.svg": 789,
	"./nexo.svg": 790,
	"./ngc.svg": 791,
	"./nio.svg": 792,
	"./nlc2.svg": 793,
	"./nlg.svg": 794,
	"./nmc.svg": 795,
	"./npxs.svg": 796,
	"./nuls.svg": 797,
	"./nxs.svg": 798,
	"./nxt.svg": 799,
	"./oax.svg": 800,
	"./ok.svg": 801,
	"./omg.svg": 802,
	"./omni.svg": 803,
	"./ong.svg": 804,
	"./ont.svg": 805,
	"./oot.svg": 806,
	"./ost.svg": 807,
	"./ox.svg": 808,
	"./part.svg": 809,
	"./pasc.svg": 810,
	"./pasl.svg": 811,
	"./pax.svg": 812,
	"./pay.svg": 813,
	"./payx.svg": 814,
	"./pink.svg": 815,
	"./pirl.svg": 816,
	"./pivx.svg": 817,
	"./plr.svg": 818,
	"./poa.svg": 819,
	"./poe.svg": 820,
	"./polis.svg": 821,
	"./poly.svg": 822,
	"./pot.svg": 823,
	"./powr.svg": 824,
	"./ppc.svg": 825,
	"./ppp.svg": 826,
	"./ppt.svg": 827,
	"./pre.svg": 828,
	"./prl.svg": 829,
	"./pungo.svg": 830,
	"./pura.svg": 831,
	"./qash.svg": 832,
	"./qiwi.svg": 833,
	"./qlc.svg": 834,
	"./qrl.svg": 835,
	"./qsp.svg": 836,
	"./qtum.svg": 837,
	"./r.svg": 838,
	"./rads.svg": 839,
	"./rap.svg": 840,
	"./rcn.svg": 841,
	"./rdd.svg": 842,
	"./rdn.svg": 843,
	"./ren.svg": 844,
	"./rep.svg": 845,
	"./req.svg": 846,
	"./rhoc.svg": 847,
	"./ric.svg": 848,
	"./rise.svg": 849,
	"./rlc.svg": 850,
	"./rpx.svg": 851,
	"./rub.svg": 852,
	"./rvn.svg": 853,
	"./ryo.svg": 854,
	"./safe.svg": 855,
	"./sai.svg": 856,
	"./salt.svg": 857,
	"./san.svg": 858,
	"./sbd.svg": 859,
	"./sberbank.svg": 860,
	"./sc.svg": 861,
	"./seth.svg": 862,
	"./shift.svg": 863,
	"./sib.svg": 864,
	"./sky.svg": 865,
	"./slr.svg": 866,
	"./sls.svg": 867,
	"./smart.svg": 868,
	"./sngls.svg": 869,
	"./snm.svg": 870,
	"./snt.svg": 871,
	"./snx.svg": 872,
	"./soc.svg": 873,
	"./spank.svg": 874,
	"./sphtx.svg": 875,
	"./srn.svg": 876,
	"./stak.svg": 877,
	"./start.svg": 878,
	"./steem.svg": 879,
	"./storj.svg": 880,
	"./storm.svg": 881,
	"./stq.svg": 882,
	"./strat.svg": 883,
	"./sub.svg": 884,
	"./sumo.svg": 885,
	"./susd.svg": 886,
	"./sys.svg": 887,
	"./taas.svg": 888,
	"./tau.svg": 889,
	"./tbx.svg": 890,
	"./tel.svg": 891,
	"./ten.svg": 892,
	"./tern.svg": 893,
	"./tgch.svg": 894,
	"./theta.svg": 895,
	"./tix.svg": 896,
	"./tkn.svg": 897,
	"./tks.svg": 898,
	"./tnb.svg": 899,
	"./tnc.svg": 900,
	"./tnt.svg": 901,
	"./tomo.svg": 902,
	"./tpay.svg": 903,
	"./trig.svg": 904,
	"./trtl.svg": 905,
	"./trx.svg": 906,
	"./tusd.svg": 907,
	"./tzc.svg": 908,
	"./ubq.svg": 909,
	"./unity.svg": 910,
	"./usd.svg": 911,
	"./usdc.svg": 912,
	"./usdt.svg": 913,
	"./usdx.svg": 914,
	"./utk.svg": 915,
	"./veri.svg": 916,
	"./vet.svg": 917,
	"./via.svg": 918,
	"./vib.svg": 919,
	"./vibe.svg": 920,
	"./vivo.svg": 921,
	"./vrc.svg": 922,
	"./vrsc.svg": 923,
	"./vtc.svg": 924,
	"./vtho.svg": 925,
	"./wabi.svg": 926,
	"./wan.svg": 927,
	"./waves.svg": 928,
	"./wax.svg": 929,
	"./wbtc.svg": 930,
	"./weth.svg": 931,
	"./wgr.svg": 932,
	"./wicc.svg": 933,
	"./wings.svg": 934,
	"./wpr.svg": 935,
	"./wtc.svg": 936,
	"./x.svg": 937,
	"./xas.svg": 938,
	"./xbc.svg": 939,
	"./xbp.svg": 940,
	"./xby.svg": 941,
	"./xcp.svg": 942,
	"./xdn.svg": 943,
	"./xem.svg": 944,
	"./xin.svg": 945,
	"./xlm.svg": 946,
	"./xmcc.svg": 947,
	"./xmg.svg": 948,
	"./xmo.svg": 949,
	"./xmr.svg": 950,
	"./xmy.svg": 951,
	"./xp.svg": 952,
	"./xpa.svg": 953,
	"./xpm.svg": 954,
	"./xrp.svg": 955,
	"./xsg.svg": 956,
	"./xtz.svg": 957,
	"./xuc.svg": 958,
	"./xvc.svg": 959,
	"./xvg.svg": 960,
	"./xzc.svg": 961,
	"./yoyow.svg": 962,
	"./zcl.svg": 963,
	"./zec.svg": 964,
	"./zel.svg": 965,
	"./zen.svg": 966,
	"./zest.svg": 967,
	"./zil.svg": 968,
	"./zilla.svg": 969,
	"./zrx.svg": 970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;